<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h1 class="titlePage" id="team">Members</h1>
        <v-divider class="div-margin" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <h1 class="director">Director</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-card elevation="2">
          <v-row justify="center">
            <v-col cols="12" md="4">
              <img
                contain
                class="imagen"
                src="https://storage.googleapis.com/zhang-lab-570b6.appspot.com/members/dSc8IQxnhhTdwbRIrGB9.jpg"
              />
              <v-card-title class="title justify-center">{{shrikeInfo[0].name}} {{shrikeInfo[0].title}}</v-card-title>
              <v-card-subtitle v-html="shrikeInfo[0].positions" class="pb-0">
              </v-card-subtitle>
            </v-col>

            <v-col cols="12" md="4">
              <v-card-text v-html="getDescription()" class="text padding-right-12"/>    
            </v-col>
            <v-col cols="12" md="4" class='margin-when-small'>
              <span v-if="getAwards()" class='text margin margin_top'>
                  <h3 class="btntext noBold margin_top">Awards and Honors:</h3>
                  <ul dense class="scroll margin">
                    <template v-for="(award,i) in shrikeInfo[0].awards.split('-')" class="margin">
                      <li :key="i" avatar class="margin">
                        <p>{{award}}</p>
                      </li>
                    </template>
                  </ul>
                  <br />
                  <p class="noBold">
                    Email: 
                    <a
                      href="mailto:yszhang@research.bwh.harvard.edu"
                    >yszhang@research.bwh.harvard.edu</a>
                  </p>
                </span>
            </v-col>
          </v-row>
          <!--<v-btn class="btn" color="white" elevation="0" href="/team/members/dSc8IQxnhhTdwbRIrGB9">
            <p class="btntext">Awards and Honors</p>
          </v-btn>-->
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "Director",
  computed: {
    ...mapState(["loadingShrike"]),
    ...mapGetters(["shrikeInfo"])
  },
  mounted() {
    if (!this.shrikeInfo.length){
      this.$store.dispatch("cargarShrike");
    //console.log(this.shrikeInfo)
    }
    //console.log('hhhhhhhhhhhhhhhhhhhhhhhh')
  },
  methods:{
    getDescription(){
      //console.log(this.shrikeInfo[0])
      if(this.shrikeInfo && this.shrikeInfo[0]){
        return this.shrikeInfo[0].description;
      }
      else{
        return 'Loading....'
      }
    },
    getAwards(){
      if(this.shrikeInfo && this.shrikeInfo[0]){
        //console.log(this.shrikeInfo[0].awards)
        return this.shrikeInfo[0].awards
      }
      return false
    }
  }
};
</script>

<style>
.titlePage {
  align-content: center;
  text-align: center;
  font-size: 2.5rem;
  text-transform: uppercase;
}
</style>

<style scoped>
.text {
  align-content: justify;
  text-align: justify;
  padding-left: 0;
  padding-right: 24px;
  font-size: 1rem;
  word-break: break-word;
}

.director {
  align-content: justify;
  text-align: justify;
  padding-left: 0;
  padding-right: 36px;
}

.btn {
  margin-bottom: 12px;
}

.margin{
  margin-right: 10px !important;
}

.margin-when-small{
  margin-right: 0px !important;
  margin-left: 0px !important;
}

@media only screen and (max-width: 958px) {
  .text {
    padding-left: 12px;
    padding-right: 12px;
    word-break: break-word;
  }
  .margin-when-small{
    margin-right: 10px !important;
    margin-left: 25px !important;
  }
}

@media only screen and (max-width: 1550px) {
  .margin_top{
    margin-top: 0px;
  }
  .scroll {
    overflow-y: scroll;
    max-height: 510px !important;
    margin-top: 12px;
  }
}

.imagen {
  border-radius: 3%;
  max-height: 350px;
  margin-top: 15px;
}

.margin_top{
  margin-top: 15px;
}

.btntext {
  color: gray;
  
  word-break: break-word;
}

.scroll {
  overflow-y: scroll;
  max-height: 350px;
  margin-top: 12px;
}

/deep/.link {
  color: #b80b0b;

  text-decoration-line: none;
}

.padding-right-12{
  padding-right: 12px;
}

.imgMargin {
  margin: 0;
  padding-bottom: 0;
}

.title {
  font-size: 1.2rem;
  font-weight: bold;
  word-break: break-word;
}

.div-margin {
  margin: 1rem 10rem 0rem 10rem;
}
</style>